import { useContext } from 'react';
import CarrierLogisticsCommonsContext from '../../context/CarrierLogisticsCommonsContext';

export function useLogisticParties() {
  const carrierLogisticsCommons = useContext(CarrierLogisticsCommonsContext);
  return carrierLogisticsCommons?.lps;
}

export default useLogisticParties;
